import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import * as UserActions from "../../redux/actions/user.actions";
import "./Login.css";

const Forgot = () => {
  const loginState = useSelector((state) => state.Login);
  const { defConfig, defLang, usertoken, success, failed, error: reduxError } = loginState; // success/failed solo se leen en el useEffect
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [email, setEmail] = React.useState("");
  const [domain, setDomain] = React.useState(process.env.REACT_APP_DEF_ORG || "");
  const [showDomain, setShowDomain] = React.useState(true);
  const [submitted, setSubmitted] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [localSuccess, setLocalSuccess] = React.useState(false);
  const [localError, setLocalError] = React.useState("");

  React.useEffect(() => {
    if (usertoken) navigate("/");
  }, [usertoken]);

  // Cuando la acción termina, capturar resultado en estado local para que no se pierda
  React.useEffect(() => {
    if (!submitted) return;
    if (success) {
      setLocalSuccess(true);
      setLoading(false);
    }
    if (failed) {
      setLocalError(reduxError || "No se pudo procesar la solicitud. Verifica tu correo e intenta nuevamente.");
      setLoading(false);
    }
    // Depende del objeto completo (no solo de success/failed) para no perderse
    // dos fallos consecutivos con el mismo valor booleano (ver ResetPassword.js).
  }, [loginState]);

  const submitForm = (e) => {
    e.preventDefault();
    if (loading) return;
    setLocalError("");
    setSubmitted(true);
    setLoading(true);
    dispatch(UserActions.RecoveryPass({ email, domain }));
  };

  const lbl = defConfig[defLang] || {};

  return (
    <div className="xflow-login-page">
      <div className="xflow-login-main">

        {/* ── Panel izquierdo ── */}
        <div className="xflow-login-panel">
          <div className="xflow-login-logo-wrap">
            <img
              src={process.env.REACT_APP_CUSTOM_LOGO_IMAGE || "/images/logo.png"}
              onError={(e) => { e.currentTarget.src = "/images/logo.png"; }}
              alt={process.env.REACT_APP_COMPANY || "xFlow"}
              className="xflow-login-logo"
            />
          </div>
          <div className="xflow-login-brand">
            <span className="xflow-kicker">xFlow Workspace</span>
            <h2>Recupera tu<br/>acceso</h2>
            <p>Te enviaremos un link para que puedas crear una nueva contraseña de forma segura.</p>
          </div>
        </div>

        {/* ── Panel derecho (formulario) ── */}
        <div className="xflow-login-form-panel">
          <div className="xflow-login-mobile-logo">
            <img
              src={process.env.REACT_APP_CUSTOM_LOGO_IMAGE || "/images/logo.png"}
              onError={(e) => { e.currentTarget.src = "/images/logo.png"; }}
              alt={process.env.REACT_APP_COMPANY || "xFlow"}
            />
          </div>

          <div className="xflow-login-card">
            <div className="xflow-login-title">
              <span className="xflow-kicker">xFlow Workspace</span>
              <h1>Recuperar contraseña</h1>
            </div>

            {localSuccess ? (
              <div className="xflow-recovery-success">
                <span className="e-icons e-check-box xflow-recovery-check"></span>
                <p>
                  Revisa tu correo, te enviamos un link para restablecer tu contraseña a <b>{email}</b>.
                </p>
                <Link to="/login" className="xflow-recovery-back-btn">
                  Ir al inicio de sesión
                </Link>
              </div>
            ) : (
              <form onSubmit={submitForm} autoComplete="on">
                <p className="xflow-recovery-hint">
                  Ingresa tu correo y te enviaremos un link para restablecer tu contraseña.
                </p>

                {localError && (
                  <div className="xflow-login-error" style={{ marginBottom: 12 }}>
                    {localError}
                  </div>
                )}

                {showDomain && (
                  <div className="xfl-field">
                    <label htmlFor="rf-domain">
                      {lbl.formorganization || "Organización"}
                    </label>
                    <input
                      id="rf-domain"
                      name="domain"
                      type="text"
                      placeholder="código de organización"
                      value={domain}
                      onChange={(e) => setDomain(e.target.value)}
                      required
                    />
                  </div>
                )}

                <div className="xfl-field">
                  <label htmlFor="rf-email">
                    {lbl.formemail || "Correo electrónico"}
                  </label>
                  <input
                    id="rf-email"
                    name="email"
                    type="email"
                    autoComplete="username"
                    placeholder="tucorreo@empresa.com"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                </div>

                <button
                  type="submit"
                  className="e-btn e-primary xflow-login-submit"
                  disabled={loading}
                  style={{ opacity: loading ? 0.7 : 1, cursor: loading ? "wait" : "pointer" }}
                >
                  {loading
                    ? "Enviando..."
                    : (lbl.recoverypassword || "Enviar link de recuperación")}
                </button>

                <div className="xflow-recovery-back">
                  <Link to="/login">← Volver al inicio de sesión</Link>
                </div>
              </form>
            )}
          </div>
        </div>
      </div>

      <div className="xflow-login-copyright text-center">
        © 2023–2026 <b>xFlow PRO versión 2</b>
      </div>
    </div>
  );
};

export default Forgot;
